module.exports = __webpack_public_path__ + "static/media/verify-icon.d7ef93d5.svg";